import React, { useState,useEffect } from 'react';
import { FaFacebook } from "react-icons/fa";
import { AiOutlineInstagram } from "react-icons/ai";
import chaticon from "../assets/images/chaticon.png"
import { Link } from 'react-router-dom';
import Chat from './Chatfile';
import { jwtDecode } from "jwt-decode";
import { socket } from './config/socket';
import axios from 'axios';

function Footer() {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    const userData = decoded.data.customer_data;
    const [isOpenAbout, setIsOpenAbout] = useState(false);
    const [isOpenServices, setIsOpenServices] = useState(false);
    const [isOpenPartners, setIsOpenPartners] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleSection = (section) => {
        switch (section) {
            case 'about':
                setIsOpenAbout(!isOpenAbout);
                break;
            case 'services':
                setIsOpenServices(!isOpenServices);
                break;
            case 'partners':
                setIsOpenPartners(!isOpenPartners);
                break;
            default:
                break;
        }
    };
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
      setIsModalOpen(false);
      
    };
    const [totalSeenCount,setTotalSeenCount]=useState(null)
    const fetchChatsList = async () => {
        let senderId = "65d733f5b09518d5aed1b2a5";
        const config = {
          url: `${config.API_BASE_URL}/bookings/getcustomerbookings/${userData.id}`,
          method: "GET",
          maxBodyLength: Infinity,
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        };
        try {
          const response = await axios.request(config);
          const data = response.data.data; // Make sure to access the correct property
    
          // Extract vendors from confirmed and upcoming bookings
          const confirmedVendors = data.Confirmed.map((booking) => ({
            vendorId: booking.sellerId,
            vendorName: booking.companyName,
            vendorContact: booking.vendorContact,
          }));
          
          const uniqueVendors = new Map();
          data.All.forEach((booking) => {
            if (!uniqueVendors.has(booking.sellerId)) {
              uniqueVendors.set(booking.sellerId, {
                vendorId: booking.sellerId,
                vendorName: booking.companyName,
                vendorContact: booking.vendorContact,
                lastMsg: booking.lastMsg,
                lastMsgdate: booking.lastMsgdate,
                seencount: booking.seenCount,
              });
            }
          });
          const allVendors = Array.from(uniqueVendors.values());

          // Calculate the total seen count for unique vendors
          const totalSeenCount = allVendors.reduce((sum, vendor) => sum + vendor.seencount, 0);
          setTotalSeenCount(totalSeenCount);
          
          // Update the chat list state with unique vendors
        } catch (error) {
          console.error("Error fetching chats:", error);
        }
      };
    
    
      useEffect(() => {
        socket.on("receive-message", fetchChatsList);
    
        return () => {
          socket.off("receive-message", fetchChatsList);
        };
      }, []);
      useEffect(() => {
        fetchChatsList();
      })
  
    return (
        <footer>
            {/* Footer Sections */}
            <div className="bg-[#344857] text-white py-8">
                <div className="">
                    <div className="flex flex-wrap justify-between container mx-auto px-6 md:px-10">

                        {/* About Fursure */}
                        <div className="w-full md:w-1/4 mb-6 md:mb-0">
                            <div className="flex justify-between items-center cursor-pointer md:hidden" onClick={() => toggleSection('about')}>
                                <h5 className="font-bold mb-2">About Find Local Pet Services</h5>
                                <span className={`transform transition-transform ${isOpenAbout ? 'rotate-180' : 'rotate-0'}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 fill-current" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a.75.75 0 0 1-.53-.22l-8-8a.75.75 0 0 1 1.06-1.06L10 15.94l7.47-7.47a.75.75 0 0 1 1.06 1.06l-8 8A.75.75 0 0 1 10 18z" />
                                    </svg>
                                </span>
                            </div>
                            <h5 className="font-bold mb-2 hidden md:block">
                                About Find Local Pet Services
                            </h5>
                            <ul className={`space-y-2 ${isOpenAbout ? 'block' : 'hidden'} md:block`}>
                                <Link to="https://findlocalpetservices.com/our-story/"><li>Our Story</li></Link>
                                <Link to="https://findlocalpetservices.com/contact-us/"><li>Contact Us</li></Link>
                                <Link to="https://findlocalpetservices.com/kennel-faq-page/"><li>FAQ Pet Boarding</li></Link>
                                <Link to="https://findlocalpetservices.com/faq-page/"><li>FAQ Pet Insurance</li></Link>
                                <Link to="https://findlocalpetservices.com/kennel-privacy-policy/"><li>Privacy Policy</li></Link>
                            </ul>
                        </div>

                        {/* Fursure Services */}
                        <div className="w-full md:w-1/4 mb-6 md:mb-0">
                            <div className="flex justify-between items-center cursor-pointer md:hidden" onClick={() => toggleSection('services')}>
                                <h5 className="font-bold mb-2">Find Local Pet Services</h5>
                                <span className={`transform transition-transform ${isOpenServices ? 'rotate-180' : 'rotate-0'}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 fill-current" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a.75.75 0 0 1-.53-.22l-8-8a.75.75 0 0 1 1.06-1.06L10 15.94l7.47-7.47a.75.75 0 0 1 1.06 1.06l-8 8A.75.75 0 0 1 10 18z" />
                                    </svg>
                                </span>
                            </div>
                            <h5 className="font-bold mb-2 hidden md:block">
                            Find Local Pet Services
                            </h5>
                            <ul className={`space-y-2 ${isOpenServices ? 'block' : 'hidden'} md:block`}>
                                <Link to="https://findlocalpetservices.com/"><li>Find Boarding</li></Link>
                                <Link to="https://findlocalpetservices.com/"><li>Get Insurance</li></Link>
                            </ul>
                        </div>

                        {/* Insurance Partners */}
                        <div className="w-full md:w-1/4 mb-6 md:mb-0">
                            <div className="flex justify-between items-center cursor-pointer md:hidden" onClick={() => toggleSection('partners')}>
                                <h5 className="font-bold mb-2">Insurance Partners</h5>
                                <span className={`transform transition-transform ${isOpenPartners ? 'rotate-180' : 'rotate-0'}`}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 fill-current" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10 18a.75.75 0 0 1-.53-.22l-8-8a.75.75 0 0 1 1.06-1.06L10 15.94l7.47-7.47a.75.75 0 0 1 1.06 1.06l-8 8A.75.75 0 0 1 10 18z" />
                                    </svg>
                                </span>
                            </div>
                            <h5 className="font-bold mb-2 hidden md:block">
                                Insurance Partners
                            </h5>
                            <ul className={`space-y-2 ${isOpenPartners ? 'block' : 'hidden'} md:block`}>
                                <Link to="https://findlocalpetservices.com/about-bajaj-allianz"><li>Bajaj Allianz</li></Link>
                                <Link to="https://findlocalpetservices.com/about-future-generali"><li>Future Generali</li></Link>
                            </ul>
                        </div>

                        {/* Get Cute puppies in your inbox */}
                        <div className="w-full md:w-1/4">
                            <h5 className="font-bold mb-2">Get Cute puppies in your inbox</h5>
                            <form className="flex mb-4">
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    className="w-full md:w-auto px-4 py-2 rounded-l-md border border-[#fff] focus:ring-2 focus:ring-blue-500 bg-transparent mr-1"
                                />
                                <button
                                    type="submit"
                                    className="bg-[#FF6216] text-white px-4 py-2 rounded-md  transition-colors duration-300"
                                >
                                    Submit
                                </button>
                            </form>
                            <p className="text-sm mb-4">By providing any email, I consent to receive marketing communications from findlocalpetservices.com/</p>
                            <div className="flex space-x-4">
                                <Link to="https://www.facebook.com/profile.php?id=61567891970357"><FaFacebook className='text-2xl fill-[#FAC63B]' /></Link>
                                <Link to="https://www.instagram.com/findlocalpetservices/profilecard/?igsh=MXExZHRqZzUxY3l1OA=="><AiOutlineInstagram className='text-2xl fill-[#344857] p-1 bg-[#FAC63B] rounded-full' /></Link>
                                
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-8 border-t border-[#FFFFFE] pt-4">
                        <p className="text-sm">By continuing past this page, you agree to our Terms and conditions, Cookie Policy, Privacy Policy and Content Policies. <b>​© FURSURE PRIVATE LIMITED</b> All rights reserved Copyrights 2024</p>
                    </div>
                </div>
            </div>
            <div className='fixed bottom-5 right-5'>  {/* This positions the container in the bottom-right */}
                <div className='relative'>
                    {totalSeenCount > 0 && (
                    <span className="absolute top-0 right-[20px] bg-red-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                        {totalSeenCount}
                    </span>
                    )}
                    <img src={chaticon} className='h-[100px] w-[100px]' onClick={openModal}/> 
                </div>
            </div>

            {isModalOpen && (
            
                  <div className="bg-white rounded-lg shadow-md p-6 w-full max-w-[400px] h-[500px] overflow-y-auto fixed bottom-0 right-0 md:min-h-0 min-h-screen" style={{boxShadow:"0px 0px 10px #000"}}>
                    
                    <Chat onClose={closeModal} />
                  
                </div>
              )}
        </footer>
    );
}

export default Footer;
